import { menuPermissions } from '../account/menupermissions';

const getAuth = () => {
  try {
    return JSON.parse(sessionStorage.getItem('authData') || '{}');
  } catch (e) {
    return {};
  }
};

// const getUserPermSet = () => {
//   try {
//     const auth = JSON.parse(sessionStorage.getItem('authData') || '{}');
//     const perms = auth?.adminRole?.permissions || [];
//     return new Set(perms);
//   } catch (e) {
//     return new Set();
//   }
// };

const getUserPermSet = () => {
  const auth = getAuth();
  return new Set(auth?.adminRole?.permissions || []);
};

const isSuperAdmin = () => {
  const auth = getAuth();
  return auth?.adminRole?.roleName === "Super Admin";
};

// check raw permission string
export const hasPermission = (permString) => {
   if (isSuperAdmin()) return true;

  const set = getUserPermSet();
  return set.has(permString);
};

// check module-level permission (e.g. manage_products)
export const canModule = (moduleValue) => {
  if (isSuperAdmin()) return true;

  const set = getUserPermSet();
  return set.has(moduleValue);
};

// check action like ('manage_products', 'edit') => checks 'manage_products.edit'
// fallback: if action not present but module present, use default from menuPermissions
export const canAction = (moduleValue, action) => {
   if (isSuperAdmin()) return true;

  const set = getUserPermSet();
  const actionPerm = `${moduleValue}.${action}`; // e.g. manage_products.edit
  if (set.has(actionPerm)) return true;

  // if module-level not present, deny
  if (!set.has(moduleValue)) return false;

  // fallback to default defined in menuPermissions
  const moduleConfig = menuPermissions.find((m) => m.value === moduleValue);
  if (!moduleConfig || !Array.isArray(moduleConfig.subPermissions)) return false;
  const sub = moduleConfig.subPermissions.find((s) => s.value === actionPerm);
  return !!(sub && sub.default);
};

// get all perms set
export const getAllPerms = () => Array.from(getUserPermSet());
